import React, { useState, useEffect } from "react";
import logo from "../assets/Worldline-Coconut-Horizontal.png";
import { useSscIam } from "../login/ssciam/useSscIam";
import { OLD_TOKEN_KEY, SSCIAM_ACCESS_TOKEN_KEY, clearLocalStorage, doubleAuthEnabled } from "./authHelper";

const doubleAuth = doubleAuthEnabled();

export const NavPaneSscIam = () => {
  const sscIam = useSscIam();
  const idToken = window.localStorage.getItem(doubleAuth ? SSCIAM_ACCESS_TOKEN_KEY : OLD_TOKEN_KEY) ?? ""; //HACK: the idToken should be availiable in keycloak but it's not due to /login redirect flow when logging in (fix this after Cognito is deprecated, see ADR.md)
  const [logoutUrl, setLogoutUrl] = useState();

  useEffect(() => {
    if (logoutUrl) {
      window.location.assign(logoutUrl);
    }
  }, [logoutUrl]);

  return (
    <nav className="nav-pane">
      <a href="/">
        <img src={logo} alt="logo" style={{ width: "135px" }} />
      </a>
      <div
        className="log-out"
        onClick={() => {
          console.log("SscIam logout()");
          sscIam
            .createLogoutUrl({
              redirectUri: `${window.location.origin}/login`,
            })
            .then((url) => {
              const urlWithHint = new URL(url);
              urlWithHint.searchParams.set("id_token_hint", idToken);
              console.log("logout url:", urlWithHint.toString());
              setLogoutUrl(() => urlWithHint.toString()); // Since this is async the actual window.location.assign() must be done synchronosly otherwise the browser will cancel the navigation, thus the state/effect implementation.
            })
            .catch((error) => {
              console.log("keycloak logout error", error);
            })
            .finally(() => {
              clearLocalStorage();
            });
        }}
      >
        Log out
      </div>
    </nav>
  );
};
